import React, { useEffect, useMemo, useState } from "react";
import { Button, Select } from "../../../../../common";
import { ReactComponent as ArrowRight } from "../../../../../../assets/icons/arrowright.svg";
import { ReactComponent as Spinner } from "../../../../../../assets/icons/spinner.svg";
import { ReactComponent as Skip } from "../../../../../../assets/icons/skipIcon.svg";
import { useSelector, useDispatch } from "react-redux";
import { useUpdateCompanyMutation, useUpdateCompanyDraftMutation, useUpdateCompanyRequestStatusMutation, useUpdateCompanyDraftEditMutation, useGetCompanyRequestStatusMutation, useFetchCompanyDraftEditMutation } from "../../../../../../store/Company/companyApiSlice";
import { setCurrentEditingCompany } from "../../../../../../store/Company/companySlice";
import useCompanyUpdate from "../useCompanyFollowUpdate"

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { ReactComponent as Verified } from "../../../../../../assets/icons/verified.svg";
import { ReactComponent as Declined } from "../../../../../../assets/icons/cancel.svg";
import { ReactComponent as Requested } from "../../../../../../assets/icons/pending.svg";
import { ReactComponent as Skipped } from "../../../../../../assets/icons/review.svg";
export const About = ({ onNext, onSkip }) => {
  const dispatch = useDispatch();
  const [employees, setEmployees] = useState("");
  const [description, setDescription] = useState("");
  const [trn, setTRN] = useState("");

  const numberOfEmployees = useMemo(() => {
    const numberOfEmployeesOptions = [
      { value: "0-5", label: "0-5 Employees" },
      { value: "6-10", label: "6-10 Employees" },
      { value: "11-50", label: "11-50 Employees" },
      { value: "51-100", label: "51-100 Employees" },
      { value: "101-500", label: "101-500 Employees" },
      { value: "501-1000", label: "501-1000 Employees" },
      { value: "1000 - 10000", label: "1000 - 10000 Employees" },
      { value: "10000+", label: "10000+ Employees" },
    ];
    return numberOfEmployeesOptions;
  }, []);

  const { currentEditingCompany } = useSelector((state) => state.company);
  const [currentEditingCompanyDraft, setcurrentEditingCompanyDraft] = useState(null);
  const { token } = useSelector((state) => state.auth);
  const [verifiedCompany, setverifiedCompany] = useState(false);

  const [updateCompany, { isLoading }] = useUpdateCompanyMutation();
  const [UpdateCompanyDraft, { isLoadingDraft }] = useUpdateCompanyDraftMutation();
  const [UpdateCompanyDraftEdit, { isLoadingDraftEdit }] = useUpdateCompanyDraftEditMutation();
  const [FetchCompanyDraftEdit, { isLoadingFetchDraft }] = useFetchCompanyDraftEditMutation();


  const [companyVerificationStatus, setcompanyVerificationStatus] = useState("pending");
  const [desacreptionEditstatus, setDescreptionEditstatus] = useState("");
  const [requestID, setrequestID] = useState(null);
  const [getCompanyRequestStatus] = useGetCompanyRequestStatusMutation();
  const [updateCompanyRequestStatus] = useUpdateCompanyRequestStatusMutation();

  const handleEmployees = (e) => {
    setEmployees(e.target.value);
  };
  const handleDescereption = (e) => {
    if (currentEditingCompany?.company_description !== e) {
      setDescreptionEditstatus("Modified")
      setDescription(e);
    }
  };
  const handleDescereptionChange = (e) => {
    // if(currentEditingCompany?.company_description !== e) {
    // setcompanyVerificationStatus("Modified")
    // setDescription(e);
    // }
  };
  
  const handleTRN = (e) => {
    const inputValue = e.target.value;
    const alphanumericUppercaseValue = inputValue.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    setTRN(alphanumericUppercaseValue);
};

  useEffect(() => {
    if (currentEditingCompany && companyVerificationStatus !== 'Modified' && desacreptionEditstatus === "") {
      fetchDraftDetails();
    }
    if (currentEditingCompany && companyVerificationStatus === 'Modified' && desacreptionEditstatus === "") {
      fetchDraftDetails();

    } else if (currentEditingCompany) {
      setEmployees(currentEditingCompany?.number_of_employees);
      // setDescription(currentEditingCompany?.company_description);
      setTRN(currentEditingCompany.TRN_no);
    }
    if (currentEditingCompany && currentEditingCompany?.verifiedCompany) {
      setverifiedCompany(true)

    }
    if (currentEditingCompany?.userCompany) {
      const companyStatus = async () => {
        let userindividualID = localStorage.getItem('userindividualID');
        let dataval = await getCompanyRequestStatus({
          companyID: currentEditingCompany.companyID,
          individualID: userindividualID || currentEditingCompany?.userCompany[0]?.individualID?.individualID,
          token,
        });
        if (dataval) {
          let statusValue = dataval.data?.filter(item => item?.companyID?.companyID == currentEditingCompany.companyID)
          if (statusValue && statusValue.length > 0) {
            let companyStatus = statusValue[statusValue.length - 1];
            setcompanyVerificationStatus(companyStatus?.status);
            setrequestID(companyStatus?.requestID);
          }
        }
      }
      companyStatus()
    }
  }, [currentEditingCompany, companyVerificationStatus]);
  const fetchDraftDetails = async () => {
    try {
      const fetchDraft = await FetchCompanyDraftEdit({
        companyId: currentEditingCompany.companyID,
        token
      }).unwrap();
      if (fetchDraft?.data) {
        setcurrentEditingCompanyDraft(fetchDraft?.data[0]);
        setEmployees(fetchDraft?.data[0]?.number_of_employees || currentEditingCompany?.number_of_employees);
        setDescription(fetchDraft?.data[0]?.company_description || currentEditingCompany?.company_description);
        setTRN(fetchDraft?.data[0]?.TRN_no || currentEditingCompany?.TRN_no);
      }
    } catch (error) {
    }
  }
  const handleSubmitDraft = async () => {
    try {
      const updatecompanyStatus = await updateCompanyRequestStatus({
        requestID: requestID,
        token
      }).unwrap();
      const res = await UpdateCompanyDraft({
        data: {
          companyID: currentEditingCompany.companyID,
          number_of_employees: employees,
          company_description: description,
          company_status: "Modified",
          TRN_no: trn
        },
        token
      }).unwrap();
      if (res) {
        setDescreptionEditstatus("")
        onNext(1, "Industry", "About");
      }

    } catch (error) {
    }
  }
  const handleSubmitDraftEdit = async () => {
    try {
      const res = await UpdateCompanyDraftEdit({
        data: {
          number_of_employees: employees,
          company_description: description,
          company_status: "Modified",
          TRN_no: trn
        },
        companyId: currentEditingCompany.companyID,
        token,
        type: "aboutcompany"
      }).unwrap();
      if (res) {
        // dispatch(setCurrentEditingCompany(res));
        onNext(1, "Industry", "About");
      }
    } catch (error) {
    }
  }

  const handleUpdateCompany = useCompanyUpdate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (currentEditingCompanyDraft == null && (companyVerificationStatus == 'Completed' || companyVerificationStatus == 'Modified')) {
      handleSubmitDraft()
    } else if (companyVerificationStatus == 'Modified') {
      handleSubmitDraftEdit()
    } else {
      try {
        const res = await updateCompany({
          data: {
            number_of_employees: employees,
            company_description: description,
            company_status: currentEditingCompany.company_status == 'Requested' ? "Requested" : "Modified",
            TRN_no: trn
          },
          token,
          companyId: currentEditingCompany.companyID,
        }).unwrap();
        if (res) {
          dispatch(setCurrentEditingCompany(res));
          const result = await handleUpdateCompany(currentEditingCompany.companyID, "About Updated", token);
          if (!result.success) {
            console.error(result.error);
          }
          onNext(1, "Industry", "About");
        }
      } catch (error) {
      }
    }

  };
  const enabledDesc = (description) => {
    var specialChars = "!@#$^&%*()+=-[]\/{}|:<>?,.";
    for (var i = 0; i < specialChars.length; i++) {
      description = description?.replace('p', "");
      description = description?.replace('br', "");
      description = description?.replace(new RegExp("\\" + specialChars[i], "gi"), "");
    }
    return description;
  }
  const CustomClipboard = ReactQuill.Quill.import('modules/clipboard');
  class PlainClipboard extends CustomClipboard {
    onPaste(e) {
      e.preventDefault();
      const text = e.clipboardData.getData('text/plain');
      const range = this.quill.getSelection();
      this.quill.insertText(range.index, text);
    }
  }

  ReactQuill.Quill.register('modules/clipboard', PlainClipboard, true);

  return (
    <div className="sm:mt-5 sm:mr-20">
      <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2 flex">
        About Company  <span className="pendingapproval">
          {
            ((currentEditingCompanyDraft && currentEditingCompanyDraft?.company_status == 'raised' || currentEditingCompanyDraft && currentEditingCompanyDraft?.company_status == 'Modified')) ? <Requested /> :
              currentEditingCompany?.company_status === "Verified" ? <Verified /> : currentEditingCompany?.company_status === "Declined" ?
                <Declined /> : currentEditingCompany?.company_status === "Skipped" ? <Skipped /> : currentEditingCompany?.company_status === "Requested" && <Requested />
          }
        </span>
      </h3>
      <div className="border border-slate rounded-lg p-8 mb-6">
        <label className="block mb-1 text-primary text-f14 font-semibold text-left">
          Company Name
        </label>
        <div className="relative mb-6">
          <input
            type="text"
            value={currentEditingCompany?.registered_company_name}
            disabled={true}
            className={`w-full focus:border-primary px-3 py-2 border border-input rounded bg-lightGray text-gray-900 text-sm block p-2.5 `}
          />
        </div>
        <Select
          label="Number of Employees"
          id="Employees"
          value={employees}
          onChange={handleEmployees}
        >
          <option
            value="">Select </option>
          {numberOfEmployees?.map((employee) => (
            <option
              key={employee.value} value={employee.value}>
              {employee.label}
            </option>
          ))}
        </Select>
        <div className="h-[170px] mb-2">
          <label className="block mb-1 text-primary text-f14 font-semibold text-left">
            Description
          </label>
          <ReactQuill
            className="h-full"
            value={description}
            onChange={handleDescereption}
            modules={{
              clipboard: {
                matchVisual: false,
              },
            }}
          />
        </div>
        <br /><br /><br />
        {/* <div>
          <label className="block mb-1 text-primary text-f14 font-semibold text-left">
            TRN No.
          </label>
          <input
            id="trn"
            value={trn}
            className="block p-2.5 w-full text-sm text-gray-900 bg-inputInterface rounded-lg border border-input focus:border-primary outline-none"
            placeholder="Enter TRN No."
            onChange={handleTRN}
          />
        </div> */}
      </div>
      <div className="actionButtons">
        <Button classes={`skipbtn relative group w-full py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center gap-4 `} onClick={() => onSkip(1, "Industry", "About")}>
          <span className="relative">
            Skip
          </span>
        </Button>
        <Button
          classes={`relative group w-full py-3 px-5 text-center text-sm font-semibold text-white bg-primary rounded-md  inline-flex items-center justify-center gap-4 `}
          onClick={handleSubmit}
        >
          <span className="relative">
            {isLoading ? <Spinner /> : "Save & Continue"}
          </span>
          <ArrowRight />
        </Button>

      </div>
    </div >
  );
};
